import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 tracking-wide uppercase">
            Product Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Discover Your Next{' '}
            <span className="text-primary-600">Kakobuy Sheet</span> Favorite
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            Browse through 14 curated categories and jump directly to the best product spreadsheets
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 card-hover cursor-pointer"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="relative w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`${cat.name} - Kakobuy Spreadsheet Finds`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={index < 8 ? 'eager' : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-[10px] font-medium rounded-full whitespace-nowrap">
                    {cat.itemCount}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-2">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  View Category
                  <i className="ri-arrow-right-up-line text-[10px]"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}